'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCompetitorInfoCards = createCompetitorInfoCards;

var _ifeisIsomorphic = require('ifeis-isomorphic');

function createCompetitorInfoCards(fPrint, drawFront, pages, feisName, fileName) {
  var doc = fPrint.create(fileName, { layout: 'landscape' });
  var metrics = fPrint.metrics(true);

  var params = {
    headlineSize: 18,
    textSize: 12,
    qHeight: metrics.useablePageHeight / 2,
    qWidth: metrics.useablePageWidth / 2 - metrics.margin,
    margin: metrics.margin,
    useablePageWidth: metrics.useablePageWidth,
    useablePageHeight: metrics.useablePageHeight,
    pageWidth: metrics.pageWidth,
    pageHeight: metrics.pageHeight
  };

  var quadrants = [{
    x: params.margin,
    y: params.margin
  }, {
    x: params.pageWidth / 2 + params.margin,
    y: params.margin
  }, {
    x: params.margin,
    y: params.pageHeight / 2 + params.margin
  }, {
    x: params.pageWidth / 2 + params.margin,
    y: params.pageHeight / 2 + params.margin
  }];

  pages.forEach(function (persons, idx) {
    if (idx > 0) doc.addPage();
    // Draw the front of the cards
    persons.forEach(function (person, q) {
      var quad = quadrants[q];

      drawFront(person, quad, params, doc);
    });

    // Draw the back of the cards, flipping the left-right order to allow for collation.
    doc.addPage();
    [1, 0, 3, 2].forEach(function (i, q) {
      var person = persons[i];
      var quad = quadrants[q];
      var sequenceNum = idx * 4 + i + 1;

      if (!person) return;

      doc.fontSize(params.headlineSize).font('Helvetica');
      doc.text(person.competitor + ': ' + person.fname + ' ' + person.lname, quad.x, quad.y, {
        width: params.qWidth,
        align: 'center',
        height: params.headlineSize,
        ellipsis: true,
        lineBreak: false
      });

      doc.text(person.school ? person.school.name : '', quad.x, quad.y + params.headlineSize, {
        width: params.qWidth,
        //height: headlineSize,
        align: 'center'
      });
      doc.fontSize(params.textSize);

      if (person.registrations.length > 0 && person.registrations[0].balance > 0) {
        doc.font('Helvetica-Oblique');
        doc.text('Balance Due', {
          width: params.qWidth,
          align: 'center'
        });
        doc.font('Helvetica');
      }

      person.registrations.forEach(function (reg, idx) {
        // Place competitions at the bottom of card
        doc.text((0, _ifeisIsomorphic.getDescription)(reg.event), quad.x, quad.y + params.pageHeight / 2 - params.margin * 2 - (params.textSize * person.registrations.length - idx * params.textSize), {
          width: params.qWidth,
          align: 'left',
          height: params.textSize,
          ellipsis: true,
          lineBreak: false
        });
      });

      // add sequence number to bottom right corner
      doc.text(sequenceNum, quad.x + params.margin / 2, quad.y + params.pageHeight / 2 - params.margin * 2 + params.textSize, {
        width: params.qWidth,
        align: 'right',
        height: params.textSize,
        ellipsis: false,
        lineBreak: false
      });

      doc.fontSize(params.textSize * 0.7);
      doc.text(feisName, quad.x, quad.y + params.pageHeight / 2 - params.margin * 2 + params.textSize, {
        width: params.qWidth,
        align: 'left',
        height: params.textSize,
        ellipsis: true,
        lineBreak: false
      });
    });
  });

  return fPrint.download(doc);
} /* 
   * A collection of helper functions to print pages used in multiple printouts
   */

// create the cards
;


//////////////////
// WEBPACK FOOTER
// ./print/common.js
// module id = 213
// module chunks = 0